import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import {
	ICmmsFilterComponent,
	ICmmsFilterEmittedValue,
} from '@app/pages/cmms/components/cmms-sort-filters-grouping/cmms-applied-filters-bar/interfaces/filter-component.interface';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AuMatInputAutofocusDirective } from '../../../../../../shared/directives/au-mat-input-autofocus.directive';
import { NgxTolgeeModule } from '@tolgee/ngx';

@Component({
	selector: 'text-filter',
	templateUrl: './text-filter.component.html',
	styleUrls: ['./text-filter.component.scss'],
	imports: [
		MatFormField,
		MatInput,
		ReactiveFormsModule,
		AuMatInputAutofocusDirective,
		NgxTolgeeModule,
	],
})
export class TextFilterComponent implements ICmmsFilterComponent, OnInit, OnDestroy {
	@Input() data: { preselectedValue?: string; columnName: string };
	@Output() filterValueChanged = new EventEmitter<ICmmsFilterEmittedValue>();

	searchControl = new FormControl<string>('');

	private destroy$ = new Subject<void>();

	ngOnInit(): void {
		this.searchControl.valueChanges
			.pipe(takeUntil(this.destroy$), distinctUntilChanged())
			.subscribe(searchValue => {
				this.filterValueChanged.emit({
					columnName: this.data?.columnName,
					label: searchValue,
					data: searchValue,
				});
			});

		if (this.data?.preselectedValue) {
			setTimeout(() => {
				this.searchControl.setValue(this.data.preselectedValue);
			});
		}
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}
}
